var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mt-n20px mt-md-n40px mb-20px"
  }, [_c('div', {
    staticClass: "d-flex justify-center pa-12px py-md-16px"
  }, [_c('v-checkbox', {
    ref: "all",
    staticClass: "ma-0 pa-0 font-weight-bold",
    attrs: {
      "input-value": _vm.user._terms.length == _vm.termsList.length,
      "label": "전체 이용약관에 동의합니다.",
      "hide-details": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.all($event);
      }
    }
  })], 1), _c('v-divider')], 1), _c('div', [_vm._l(_vm.termsList, function (terms, index) {
    return _c('div', {
      key: terms._id,
      class: {
        'mt-40px mt-md-60px': !!index
      }
    }, [_c('v-layout', {
      attrs: {
        "no-gutters": "",
        "align-center": ""
      }
    }, [_c('span', [_c('b', [_vm._v(_vm._s("".concat(terms.subject, " ").concat(terms.required ? "(필수)" : "(선택)")))])]), _c('v-spacer'), _c('v-checkbox', {
      staticClass: "mt-0",
      attrs: {
        "value": terms._id,
        "label": "동의",
        "hide-details": "",
        "multiple": ""
      },
      model: {
        value: _vm.user._terms,
        callback: function callback($$v) {
          _vm.$set(_vm.user, "_terms", $$v);
        },
        expression: "user._terms"
      }
    })], 1), _c('v-sheet', {
      staticClass: "mt-3",
      attrs: {
        "width": "100%",
        "height": "2",
        "color": "primary"
      }
    }), _c('v-sheet', _vm._b({
      staticClass: "overflow-auto pa-4",
      attrs: {
        "outlined": "",
        "hide-details": "",
        "max-height": "200"
      }
    }, 'v-sheet', _vm.$attrs, false), [_c('p', {
      domProps: {
        "innerHTML": _vm._s(terms === null || terms === void 0 ? void 0 : terms.content)
      }
    })])], 1);
  }), _c('div', {
    staticClass: "mt-20px mt-md-40px"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "width": "120",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.next();
      }
    }
  }, [_vm._v("동의")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "width": "120",
      "color": "primary",
      "outlined": "",
      "to": "/"
    }
  }, [_vm._v("동의안함")])], 1)], 1)], 1)], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }